import React, {Component} from "react";
import { Form, Input, InputNumber, Select} from "antd";
const EditableContext = React.createContext();
export {EditableContext}
const {Option} = Select;
export default class EditableCell extends Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />;
        }
        if(this.props.options){
            return (
                <Select>
                    {Object.keys(this.props.options).map((key)=>(
                        <Option value={key} key={key}>{this.props.options[key]}</Option>
                    ))}
                </Select>
            )
        }
        return <Input />;
    };

    renderCell = ({ getFieldDecorator }) => {
        const {
            editing,
            required,
            dataIndex,
            title,
            inputType,
            record,
            index,
            children,
            options,
            ...restProps
        } = this.props;
        let value =""
        if(record) {
            value = record[dataIndex]===null?"":record[dataIndex]
        }
        if(value===undefined){
            value=""
        }
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: required,
                                    message: `请输入 ${title}!`,
                                },
                            ],
                            initialValue: inputType === 'number'? value:value+"",
                        })(this.getInput())}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

    render() {
        return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>;
    }
}